<header id="header" class="position_relative p-0 m-0">
    <video playsinline autoplay muted loop id="myVideo" class="hero_header" oncanplay="this.play()"
        onloadedmetadata="this.muted = true">
        <source src="assets/video/bgVideo_v2.mp4" type="video/mp4">
        Your browser does not support HTML5 video.
    </video>
    <div class="header_text scroll-animations container-fluid p-0">
        <div class="header_text_container position__relative">
            <h1 class="header_title animated mb-3">SOLUCIONES DIGITALES</h1>
            <p class="header_subtitle animated"> Aportamos innovación tecnológica flexible a tu negocio</p>
        </div>
    </div>
</header>

<section class="section-bg-dark scroll-animations parallax-container" data-parallax="scroll" data-bleed="10"
    data-speed="0.2" data-natural-width="1400" data-natural-height="1400">
    <div class="container">
        <div class="row animated">
            <div class="col">
                <h2 class="section-title-clear">Expertos en transformación digital</h2>
                <hr class="line">
                <p class="section-text-clear">Analizamos el negocio de cada empresa para desarrollar la estrategia y la
                    metodología que mejor se adapta a cada proceso. <br> Nuestra organización presta soporte a los
                    equipos tecnológicos del cliente de manera integral, agilizando la integración en el sistema
                    digital.</p>
            </div>
        </div>
    </div>
</section>

<section id="services">
    <div class="container">
        <div class="row">
            <div class="col animated">
                <h2 class="section-title-black">Nuestros Servicios</h2> <span><i class="fas fa-chevron-down"></i></span>
            </div>
        </div>
        <div class="services-cards col-md-12">
            <div class="row">
                @for (section of sections; track section) {
                <div class="col-sm-6 col-md-6 col-lg-4 bubbles animated">
                    <a href="{{ section.link }}" class="service-card">
                        <img src="{{ section.icon }}" alt="Desarrollo de Apps" class="image-services">
                        <div class="overlay-text animated fadeInUp">
                            <h4 class="overlay-title">{{ section.title }}</h4>
                            <p class="overlay-p">{{ section.description }}</p>
                        </div>
                    </a>
                </div>
                }
            </div>
        </div>
    </div>
</section>



<section class="scroll-animations skills">
    <div class="container">
        <div class="row">
            <div class="col">
                <h2 class="section-title-black">Lo que nos representa</h2>
            </div>
        </div>
        <div class="row">
            @for (card of cards; track card) {
            <div class="col-s-12 col-sm-6 col-md-3 align__text-center icons_container">
                <div class="icons_standar icons_gray">

                    <img src="{{ card.icon }}" alt="icon" class="filter">

                </div>

                <div class="icon_text">
                    <h3 class="icon-title">{{ card.title }}</h3>
                    <hr class="line_animated">
                    <p class="icon_paragraph">{{ card.description }}
                    </p>
                </div>
            </div>
            }
        </div>
    </div>
</section>

<section id="proyects" class="scroll-animations">
    <div class="container">
        <div class="row">
            <div class="col animated">
                <h2 class="section-title-black">Casos de Éxito</h2>
            </div>
        </div>
        <div class="row mb-3">
            @for (case of cases; track case) {
            <div class="col-sm-12 col-md-4 proyects_cards align__text-center mb-1">
                <div class="cases_cards">
                    <a href="{{ case.link }}">
                        <img src="{{ case.image }}" alt="Consultoría digital" class="image_cards">
                        <div class="overlay_cards">
                            <div class="text_cards">{{ case.text }}</div>
                        </div>
                    </a>
                </div>
            </div>
            }
        </div>
    </div>
</section>